import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Tab from '../../../components/Tab';
import { transformDataColumns } from '../../../utils/transformDataColumns';

const messages = defineMessages({
  title: {
    id: 'hubs.organizations-and-services.organizations.title',
    defaultMessage: 'Organizations Available',
  },
  academicClubs: {
    id: 'hubs.organizations-and-services.organizations.academicClubs',
    defaultMessage: 'Academic clubs',
  },
  academicFratSor: {
    id: 'hubs.organizations-and-services.organizations.academicFratSor',
    defaultMessage: 'Academic Frat./Sor.',
  },
  business: {
    id: 'hubs.organizations-and-services.organizations.business',
    defaultMessage: 'Business',
  },
  choir: {
    id: 'hubs.organizations-and-services.organizations.choir',
    defaultMessage: 'Choir',
  },
  commuter: {
    id: 'hubs.organizations-and-services.organizations.commuter',
    defaultMessage: 'Commuter',
  },
  concertBand: {
    id: 'hubs.organizations-and-services.organizations.concertBand',
    defaultMessage: 'Concert Band',
  },
  environmental: {
    id: 'hubs.organizations-and-services.organizations.environmental',
    defaultMessage: 'Environmental',
  },
  gayAndLesbian: {
    id: 'hubs.organizations-and-services.organizations.gayAndLesbian',
    defaultMessage: 'Gay And Lesbian',
  },
  honorsAcademic: {
    id: 'hubs.organizations-and-services.organizations.honorsAcademic',
    defaultMessage: 'Honors/Academic',
  },
  international: {
    id: 'hubs.organizations-and-services.organizations.international',
    defaultMessage: 'International',
  },
  jazzBand: {
    id: 'hubs.organizations-and-services.organizations.jazzBand',
    defaultMessage: 'Jazz Band',
  },
  literaryMagazine: {
    id: 'hubs.organizations-and-services.organizations.literaryMagazine',
    defaultMessage: 'Literary Magazine',
  },
  marchingBand: {
    id: 'hubs.organizations-and-services.organizations.marchingBand',
    defaultMessage: 'Marching Band',
  },
  minorityCultural: {
    id: 'hubs.organizations-and-services.organizations.minorityCultural',
    defaultMessage: 'Minority Cultural',
  },
  minorityStudent: {
    id: 'hubs.organizations-and-services.organizations.minorityStudent',
    defaultMessage: 'Minority Student',
  },
  newspaper: {
    id: 'hubs.organizations-and-services.organizations.newspaper',
    defaultMessage: 'Newspaper',
  },
  orchestra: {
    id: 'hubs.organizations-and-services.organizations.orchestra',
    defaultMessage: 'Orchestra',
  },
  phiBetaKappa: {
    id: 'hubs.organizations-and-services.organizations.phiBetaKappa',
    defaultMessage: 'Phi Beta Kappa',
  },
  phiThetaKappa: {
    id: 'hubs.organizations-and-services.organizations.phiThetaKappa',
    defaultMessage: 'Phi Theta Kappa',
  },
  physicallyChallenged: {
    id: 'hubs.organizations-and-services.organizations.physicallyChallenged',
    defaultMessage: 'Physically Challenged',
  },
  politicalActivism: {
    id: 'hubs.organizations-and-services.organizations.politicalActivism',
    defaultMessage: 'Political Activism',
  },
  preDental: {
    id: 'hubs.organizations-and-services.organizations.preDental',
    defaultMessage: 'Pre-Dental',
  },
  preLaw: {
    id: 'hubs.organizations-and-services.organizations.preLaw',
    defaultMessage: 'Pre Law',
  },
  preMedical: {
    id: 'hubs.organizations-and-services.organizations.preMedical',
    defaultMessage: 'Pre-Medical',
  },
  preVeterinary: {
    id: 'hubs.organizations-and-services.organizations.preVeterinary',
    defaultMessage: 'Pre-Veterinary',
  },
  radioStation: {
    id: 'hubs.organizations-and-services.organizations.radioStation',
    defaultMessage: 'Radio Station',
  },
  religious: {
    id: 'hubs.organizations-and-services.organizations.religious',
    defaultMessage: 'Religious',
  },
  sportsIntramurals: {
    id: 'hubs.organizations-and-services.organizations.sportsIntramurals',
    defaultMessage: 'Sports/Intramurals',
  },
  studentGovernment: {
    id: 'hubs.organizations-and-services.organizations.studentGovernment',
    defaultMessage: 'Student Government',
  },
  substanceAbuseSupport: {
    id: 'hubs.organizations-and-services.organizations.substanceAbuseSupport',
    defaultMessage: 'Substance Abuse Support',
  },
  televisionStation: {
    id: 'hubs.organizations-and-services.organizations.televisionStation',
    defaultMessage: 'Television Station',
  },
  theatreDrama: {
    id: 'hubs.organizations-and-services.organizations.theatreDrama',
    defaultMessage: 'Theatre Drama',
  },
  yearbook: {
    id: 'hubs.organizations-and-services.organizations.yearbook',
    defaultMessage: 'Yearbook',
  },
});

function Organizations({ intl, organizations }) {
  const [leftSide, rightSide] = transformDataColumns(organizations, organizations);

  return (
    <Tab.Pane>
      <h3>{intl.formatMessage(messages.title)}</h3>
      <div className="row">
        <ul className="column">
          {leftSide.map(key => (
            <li key={key}>{intl.formatMessage(messages[key])}</li>
          ))}
        </ul>
        <ul className="column">
          {rightSide.map(key => (
            <li key={key}>{intl.formatMessage(messages[key])}</li>
          ))}
        </ul>
      </div>
    </Tab.Pane>
  );
}

Organizations.propTypes = {
  organizations: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(Organizations);
